import React from "react";

class VoicePricingBanner extends React.Component {
  render() {
    return (
      <div id="voice-pricing-hero" className="main-banner item-bg-one">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="main-banner-text">
                    <h4>Voice Pricing</h4>
                    <h1>
                      Simple <span>US Rates</span>
                    </h1>
                    <p>Transparent usage pricing with clear monthly fees.</p>
                    <a href="/#contact" className="btn btn-primary">
                      Talk to Sales
                    </a>
                    <a href="/#services" className="btn btn-primary view-work">
                      View Services
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default VoicePricingBanner;
